export default __webpack_public_path__ + "static/media/diet-red.c6ca08c1.svg";